var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 5.16699L6.77726 8.97729C7.21804 9.28583 7.43844 9.44011 7.67816 9.49986C7.88991 9.55265 8.11139 9.55265 8.32314 9.49986C8.56287 9.44011 8.78326 9.28583 9.22404 8.97729L14.6673 5.16699M4.53398 13.8337H11.4673C12.5874 13.8337 13.1475 13.8337 13.5753 13.6157C13.9516 13.4239 14.2576 13.118 14.4493 12.7416C14.6673 12.3138 14.6673 11.7538 14.6673 10.6337V6.36699C14.6673 5.24689 14.6673 4.68683 14.4493 4.25901C14.2576 3.88269 13.9516 3.57673 13.5753 3.38498C13.1475 3.16699 12.5874 3.16699 11.4673 3.16699H4.53398C3.41388 3.16699 2.85383 3.16699 2.426 3.38498C2.04968 3.57673 1.74372 3.88269 1.55197 4.25901C1.33398 4.68683 1.33398 5.24689 1.33398 6.36699V10.6337C1.33398 11.7538 1.33398 12.3138 1.55197 12.7416C1.74372 13.118 2.04968 13.4239 2.426 13.6157C2.85383 13.8337 3.41388 13.8337 4.53398 13.8337Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 5.16699L6.77726 8.97729C7.21804 9.28583 7.43844 9.44011 7.67816 9.49986C7.88991 9.55265 8.11139 9.55265 8.32314 9.49986C8.56287 9.44011 8.78326 9.28583 9.22404 8.97729L14.6673 5.16699M4.53398 13.8337H11.4673C12.5874 13.8337 13.1475 13.8337 13.5753 13.6157C13.9516 13.4239 14.2576 13.118 14.4493 12.7416C14.6673 12.3138 14.6673 11.7538 14.6673 10.6337V6.36699C14.6673 5.24689 14.6673 4.68683 14.4493 4.25901C14.2576 3.88269 13.9516 3.57673 13.5753 3.38498C13.1475 3.16699 12.5874 3.16699 11.4673 3.16699H4.53398C3.41388 3.16699 2.85383 3.16699 2.426 3.38498C2.04968 3.57673 1.74372 3.88269 1.55197 4.25901C1.33398 4.68683 1.33398 5.24689 1.33398 6.36699V10.6337C1.33398 11.7538 1.33398 12.3138 1.55197 12.7416C1.74372 13.118 2.04968 13.4239 2.426 13.6157C2.85383 13.8337 3.41388 13.8337 4.53398 13.8337Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailView);
export default __webpack_public_path__ + "static/media/mail-view.d5f5b6079caaa561c2cced889a964262.svg";
export { ForwardRef as ReactComponent };